var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightHand(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90.799,
    height: 116.044,
    viewBox: "0 0 90.799 116.044",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "right_hand",
    transform: "translate(-284.22 -426.619)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2633",
    "data-name": "Group 2633",
    transform: "translate(286.234 428.625)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1860",
    "data-name": "Path 1860",
    d: "M10804.421,1423.988c-5.326-5.326-10.832-6.881-15.02-10.852-11.148-6.346-18.3,7.788-9.447,14.917,14.438,8.358,19.25,23.4,33.344,31.44,15.188,11.308,59.24-6.982,47.473-52.695-.436-3.068-.055-12.927-3.092-14.765-11.846-7.168-11.787,6.032-11.562,6.712,1.4-15.427-15.889-14.777-15.066.389.322,5.967,0-12.427-7.1-12.427-8.875,0-6.58,8.723-7.1,15.977-2.16-3.923-5.848-26.95-12.428-40.831-2.914-6.148-5.484-12.969-12.428-10.653-5.324,1.777-2.711,11.93-1.773,15.979C10795.374,1386.01,10799.534,1405.419,10804.421,1423.988Z",
    transform: "translate(-10775.979 -1350.739)",
    fill: "#f3a65a",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("text", {
    id: "R",
    transform: "translate(330 518)",
    fill: "#fff",
    fontSize: 30,
    fontFamily: "Quicksand-Bold, Quicksand",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "R")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightHand);
export default __webpack_public_path__ + "static/media/right_hand.e23cf60da7815c54902baa7f5e53cc64.svg";
export { ForwardRef as ReactComponent };